import Request from './baseRequest'

const getUserToken = () => {
	return JSON.parse(localStorage.getItem('auth.currentUser')).token;
}

const _getCustomers = params => { 
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  const url= params? `${window.config.VUE_APP_BACKEND}/api/customers/v2?${params.q}` : `${window.config.VUE_APP_BACKEND}/api/customers/v2`
  
  return Request.get(
    url,
    config
  )
}

const _getCustomersByAudience = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  const url= params? `${window.config.VUE_APP_BACKEND}/api/customers/?${params.q}` : `${window.config.VUE_APP_BACKEND}/api/customers/`

  return Request.get(
    url,
    config
  )
}

// Members of an audience, listed by the audience explorer from DuckDB instead of the
// Mongo _audiences filter _getCustomersByAudience uses (slow on big audiences).
// Returns flat rows: { id, email, name, lastname, phone, totalAmount, totalOrders }.
const _getAudienceCustomers = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(`${window.config.VUE_APP_BACKEND}/api/customers/audiences/list?${params.q}`, config)
}

const _getCustomersCountries = params => { 
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  const url= params? `${window.config.VUE_APP_BACKEND}/api/customers/countries?${params.q}` : `${window.config.VUE_APP_BACKEND}/api/customers/countries`


  return Request.get(
    url,
    config
  )
}

const _getCustomersCountryCities = (countryId, q) => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  const id = encodeURIComponent(countryId)
  const params = new URLSearchParams()
  if (q) params.set('q', q)
  params.set('limit', '50')
  const qs = params.toString()
  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/customers/countries/${id}/cities${qs ? `?${qs}` : ''}`,
    config
  )
}

const _getRFMSegments = params => { 
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  const url= params? `${window.config.VUE_APP_BACKEND}/api/customers/segments-rfm?${params.q}` : `${window.config.VUE_APP_BACKEND}/api/customers/segments-rfm`


  return Request.get(
    url,
    config
  )
}


const _getProcessedDates = projectId => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/customers/processed-dates?projectId=${projectId}`,
    config
  )
}


const _createCDPCustomer = (project, payload) => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(
    `${window.config.VUE_APP_BACKEND}/api/customers/cdp/${project}`,
    payload,
    config
  )
}


const _updateCDPCustomer = (project, id, payload) => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }
  return Request.patch(
    `${window.config.VUE_APP_BACKEND}/api/customers/cdp/${project}/${encodeURIComponent(id)}`,
    payload,
    config
  )
}

const _getCDPCustomer = (project, id) => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }
  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/customers/cdp/${project}/${encodeURIComponent(id)}`,
    config
  )
}


// Interacciones de un customer (CDP, ClickHouse). Usado por "Probar journey"
// para elegir la compra/interaccion que dispara.
const _getCustomerInteractions = (project, id, params) => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }
  const qs = params && params.q ? `?${params.q}` : ''
  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/customers/cdp/interactions/${project}/${encodeURIComponent(id)}${qs}`,
    config
  )
}

export default {
  createCDPCustomer: _createCDPCustomer,
  updateCDPCustomer: _updateCDPCustomer,
  getCDPCustomer: _getCDPCustomer,
  getCustomerInteractions: _getCustomerInteractions,
  getCustomers : _getCustomers,
  getCustomersByAudience : _getCustomersByAudience,
  getAudienceCustomers : _getAudienceCustomers,
  getCustomersCountries: _getCustomersCountries,
  getCustomersCountryCities: _getCustomersCountryCities,
  getRFMSegments: _getRFMSegments,
  getProcessedDates: _getProcessedDates
}